// 导入配置好的axios实例
import apiClient from '@/api/index';

// 创建充值订单（旧版，保留以兼容）
export const createRechargeOrder = (data) => {
    return apiClient.post('/recharge/create', data);
};

// 创建VIP订单
export const createVipOrder = (data) => {
    return apiClient.post('/vip/create-order', data);
};

// 获取充值订单列表
export const getRechargeOrders = (data) => {
    return apiClient.post('/recharge/getrechargeorders', data);
};

// 查询单个充值订单
export const queryRechargeOrder = (params) => {
    return apiClient.post('/recharge/query', params);
};

// 获取充值套餐列表（旧版，保留以兼容）
export const getRechargePackages = () => {
    return apiClient.get('/recharge/packages');
};

// 获取VIP套餐列表
export const getVipPackages = () => {
    return apiClient.get('/vip/packages');
};

// 获取用户余额
export const getUserBalance = () => {
    return apiClient.post('/user/balance', {});
};

// 获取用户VIP状态
export const getUserVipStatus = () => {
    return apiClient.get('/vip/status');
};